module.exports = __webpack_public_path__ + "assets/scoober-logo-desktop-he-219e11.svg";